export default __webpack_public_path__ + "static/media/panorame.d396e0f2.svg";